<template>
	<div class="yj-verify">
		<!-- 嵌入式 -->
		<div class="slider-code" v-if="trigger === 'embed'">
			<!-- 图片滑块区 -->
			<div class="panel-wrap">
				<div class="panel-wrap-inner">
					<!-- 加载层 -->
					<div v-if="loading" class="loading-wrap">
						<div class="loading-inner">
							<i class="yj-icon-loading"></i>
							<span class="loadtext">加载中...</span>
						</div>
					</div>
					
					<!-- 操作按钮 -->
					<div class="tools-wrap" v-if="status === 'pause' && !loading && !validating">
						<i @click="refresh" class="yj-icon-refresh"></i>
					</div>
					
					<!-- 滑块图片 -->
					<div class="img-wrap">
						<img v-show="picture.bigImg" class="big-img" :src="picture.bigImg">
						<img v-show="picture.smallImg" class="small-img" :style="getLeftPosition" :src="picture.smallImg">
					</div>
				</div>
			</div>
			
			<!-- 滑块拖拽区 -->
			<div class="control-wrap">
				<!-- 滑块拖拽轨迹 -->
				<div class="slider-track" :class="getCgeckStatusStyle" :style="getMoveDistance"></div>
				
				<!-- 滑块轨道 -->
				<div class="slider-bar">
					{{getTipsTxt}}
				</div>
				
				<!-- 拖拽滑块 -->
				<div class="slider-block"  :class="getCgeckStatusStyle" ref="embedSliderBlock">
					<i :class="getSliderBlockStyle"></i>
				</div>
			</div>
		</div>
	
		<!-- 弹出式 -->
		<div class="slider-code-dialog" :style="getDialogStyle" v-else-if="trigger === 'dialog'">
			<!-- 弹窗 -->
			<div class="dialog_wrap">
				<!-- 弹窗标题 -->
				<div class="dialog_title">
					请完成安全验证<i class="yj-icon-small-close" @click="hide"></i>
				</div>	
				
				<!-- 弹窗主要内容 -->
				<div class="dialog_body">
					<!-- 滑块验证 -->
					<div class="slider-code">
						<!-- 图片滑块区 -->
						<div class="panel-wrap">
							<div class="panel-wrap-inner">
								<!-- 加载层 -->
								<div v-if="loading" class="loading-wrap">
									<div class="loading-inner">
										<i class="yj-icon-loading"></i>
										<span class="loadtext">加载中...</span>
									</div>
								</div>
								
								<!-- 操作按钮 -->
								<div class="tools-wrap" v-if="status === 'pause' && !loading && !validating">
									<i @click="refresh" class="yj-icon-refresh"></i>
								</div>
								
								<!-- 滑块图片 -->
								<div class="img-wrap">
									<img v-show="picture.bigImg" class="big-img" :src="picture.bigImg">
									<img v-show="picture.smallImg" class="small-img" :style="getLeftPosition" :src="picture.smallImg">
								</div>
							</div>
						</div>
						
						<!-- 滑块拖拽区 -->
						<div class="control-wrap">
							<!-- 滑块拖拽轨迹 -->
							<div class="slider-track" :class="getCgeckStatusStyle" :style="getMoveDistance"></div>
							
							<!-- 滑块轨道 -->
							<div class="slider-bar">
								{{getTipsTxt}}
							</div>
							
							<!-- 拖拽滑块 -->
							<div class="slider-block"  :class="getCgeckStatusStyle" ref="dialogSliderBlock">
								<i :class="getSliderBlockStyle"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 触发式 -->
		<div class="slider-code" v-else-if="trigger === 'hover'" @mouseover="showSliderCode(true)" @mouseleave ="showSliderCode(false)">
			<transition name="yj-zoom-in-bottom">
				<!-- 图片滑块区 -->
				<div class="panel-wrap hoverTrigger" v-show="isShowImg" >
					<div class="panel-wrap-inner">
						<!-- 加载层 -->
						<div v-if="loading" class="loading-wrap">
							<div class="loading-inner">
								<i class="yj-icon-loading"></i>
								<span class="loadtext">加载中...</span>
							</div>
						</div>
						
						<!-- 操作按钮 -->
						<div class="tools-wrap" v-if="status === 'pause' && !loading && !validating">
							<i @click="refresh" class="yj-icon-refresh"></i>
						</div>
						
						<!-- 滑块图片 -->
						<div class="img-wrap">
							<img v-show="picture.bigImg" class="big-img" :src="picture.bigImg">
							<img v-show="picture.smallImg" class="small-img" :style="getLeftPosition" :src="picture.smallImg">
						</div>
					</div>
				</div>
			</transition>
			
			<!-- 滑块拖拽区 -->
			<div class="control-wrap" >
				<!-- 滑块拖拽轨迹 -->
				<div class="slider-track" :class="getCgeckStatusStyle" :style="getMoveDistance"></div>
				
				<!-- 滑块轨道 -->
				<div class="slider-bar">
					{{getTipsTxt}}
				</div>
				
				<!-- 拖拽滑块 -->
				<div class="slider-block"  :class="getCgeckStatusStyle" ref="hoverSliderBlock">
					<i :class="getSliderBlockStyle"></i>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'YjSliderVerify',

		props: {
			trigger: {
				type: String,
				default: 'embed'
			},
			picture: {
				type: Object,
				required: true
			},
			loading: {
				type: Boolean,
				default: true
			},
		},

		data() {
			return {
				result: '',
				// 标识校验状态
				validating: false,	
				// 滑块状态
				status: 'pause',
				// 实时记录滑块位移
				left: 0,
				
				// 标识滑块验证图是否显示
				isShowImg: false,	
				
				// 标识弹窗是否显示
				visible: false,
				// 弹窗层级
				zIndex: 0,
			};
		},

		computed: {
			/**
			 * description： 滑块拖拽区文字提示
			 *
			 * created by panjm on 2019-10-31
			 */
			getTipsTxt(){
				if(this.status === 'pause') {
					if(this.loading){
						return "加载中...";
					} else if(this.validating){
						return "";
					} else {
						return "向右拖动滑块填充拼图";
					}
				} else if(this.status === 'pass'){
					return "";
				} else if(this.status === 'fail'){
					return "";
				} else {
					return "";
				}
			},
			/**
			 * description： 计算滑块样式
			 *
			 * created by panjm on 2019-10-31
			 */
			getSliderBlockStyle(){
				if(this.validating){
					return 'yj-icon-loading';
				} else if(this.status === 'pause'){
					return 'yj-icon-small-arrowr';
				}else if(this.status === 'drag'){
					return 'yj-icon-small-arrowr';
				}else if(this.status === 'pass'){
					return 'yj-icon-small-sure';
				}else if(this.status === 'fail'){
					return 'yj-icon-small-close';
				}
			},
			/**
			 * description： 计算拖拽块、拖拽轨迹样式
			 *
			 * created by panjm on 2019-10-31
			 */
			getCgeckStatusStyle(){
				if(this.validating){
					return 'isValidate';
				} else if(this.loading){
					return 'isDisabled';
				} else if(this.status === 'drag'){
					return 'isDrag';
				} else if(this.status === 'pass'){
					return 'isPass';
				} else if(this.status === 'fail'){
					return 'isFail';
				} else{
					return '';
				}
			},
			/**  
			 * description： 获取滑动左边距
			 *
			 * created by panjm on 2019-10-31
			 *
			 */
			getLeftPosition(){
				if(this.left < 264) {
					return 'left:'+ this.left +'px';
				} else {
					return 'left: 264px';
				}
			},
			/**  
			 * description： 获取滑动位移
			 *
			 * created by panjm on 2019-10-31
			 *
			 */
			getMoveDistance(){
				return ' width:'+ (this.left + 39) +'px';
			},
			/**
			 * description： 是否显示滑块图片
			 *
			 * created by panjm on 2019-10-31
			 */
			getImgClass(){
				return this.isShowImg ? 'slider-show' : 'slider-hide';
			},
			/**
			 * description： 设置弹窗样式
			 *
			 * created by panjm on 2019-10-31
			 */
			getDialogStyle(){
				return this.visible ? `display:block;z-index:${this.zIndex};` : `display:none;z-index:${this.zIndex}`;
			},
		},

		methods: {
			/**
			 * description：校验结果回调处理
			 * @param {Boolean} value 校验结果：true 校验通过，false 校验失败
			 * 
			 * created by panjm on 2019-10-31
			 * 
			 */
			setCheck(value){
				// 关闭校验中效果
				this.validating = false;
				
				// 判断验证结果
				if(value){
					this.status = 'pass';
					
					// 判断当前是否为触发式
					if(this.trigger === "hover"){
						// 修改滑块验证显示状态
						this.isShowImg = false;
					}
					
					// 判断当前是否为弹窗式
					if(this.trigger === "dialog"){
						setTimeout(() => {
							// 关闭弹窗
							this.hide();
						}, 1000);
					}
				} else {
					this.status = 'fail';
					
					// 定时器复位滑块
					let st = setTimeout(() => {
						this.left = 0;
						let el = this.$refs[this.trigger + "SliderBlock"];
						
						// 重置滑块位置
						if(el){
							el.style.left = '0';
						}
						
						// 重置验证码状态
						this.status = 'pause';
						// 刷新验证码
						this.refresh();
						
						clearTimeout(st);
					}, 1000);
				}
			},
			/**  
			 * description： 刷新验证码
			 *
			 * created by panjm on 2019-10-31
			 *
			 */
			refresh(){
				if(this.status === 'pause') {
					// 通知父组件刷新验证码
					this.$emit('refresh');
				} 
			},
			/**
			 * description： 拖拽事件绑定
			 *
			 * created by panjm on 2019-10-31
			 */
			bindInit(){
				let that = this;
				let el = this.$refs[this.trigger + "SliderBlock"];
				
				// 鼠标按下事件
				el.onmousedown = function(e){
					// 判断滑块验证是否处于加载状态、校验状态、校验成功或校验失败
					if(that.loading || that.validating || that.status === 'pass' ||  that.status === 'fail') {
						return false;
					}
					
					that.status = 'drag';
		            let divx = e.clientX - el.offsetLeft;
					
					// 鼠标移动事件
		            document.onmousemove = function(e){
						// 在拖拽时，禁止文字选中
						window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
						
		                let l = e.clientX - divx;
						
		                if(l >= 0 && l <= 278){
		                	el.style.left = l + 'px';
		                	that.left = l;
		                } else if(l < 0) {
							el.style.left = '0';
							that.left = 0;
						} else if(l > 278) {
							el.style.left = '278px';
							that.left = 278;
						}
		            };
					
					// 鼠标松开事件
		            document.onmouseup = function(e){
						// 重置滑块状态
						that.status = 'pause';
						// 开启校验中效果
						that.validating = true;
						// 通知父组件校验结果
		            	that.$emit("on-check", that.left, that.setCheck);
						
						// 解除事件绑定
		                document.onmousemove = null;
		                document.onmouseup = null;
		            };
		        }
			},
			/**
			 * description： 是否显示滑块图片
			 * @param {Boolean} value
			 * 
			 * created by panjm on 2019-10-31
			 * 
			 */
			showSliderCode(value){
				// 判断当前是否处于拖拽操作
				if(this.status === 'drag' || this.status === 'pass'){
					return;
				}
				
				// 修改滑块验证显示状态
				this.isShowImg = value;
			},
			/**
			 * description： 打开验证弹出窗
			 *
			 * created by panjm on 2019-10-31
			 *
			 */
			show(){
				if(this.trigger !== 'dialog') return;
				
				let parent = this.$el.parentNode;
				
				if(parent.querySelector('.yj-verify-mask') == null){
					// 给父节点增加position relative属性
					parent.style.position = 'relative';
				
					// 父节点的层级
					let zIndex = parent.style.zIndex || 0;
					// 创建遮罩层el
					let div = document.createElement('div');
					div.style.display = "block";
					div.style.zIndex = zIndex+1;
					div.className = "yj-verify-mask";
					// 加入到父节点中
					parent.appendChild(div);
					// 弹出窗层级别遮罩层多1
					this.zIndex = zIndex+2;
				}else{
					parent.querySelector('.yj-verify-mask').style.display = "block";
				}
				
				// 在父节点添加遮罩层
				this.visible = true;
			},
			/**
			 * description： 关闭验证弹出窗
			 *
			 * created by panjm on 2019-10-31
			 *
			 */
			hide(){
				if(this.trigger !== 'dialog') return;
				// 父节点
				let parent = this.$el.parentNode;;
					
				parent.querySelector('.yj-verify-mask').style.display = "none";
				
				this.visible = false;
			},
		},
		
		mounted(){
			// 事件绑定
			this.bindInit();
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/slider-verify/src/slider-verify.vue